import {
  Cancel,
  Check,
  Clear,
  DoneAll,
  Moped,
  Schedule,
  Shuffle,
} from "@mui/icons-material";
import moment from "moment";

export const OrderPlaced = ({ name, time, paymentStatus }) => {
  return (
    <div className="py-3  flex flex-col gap-2 px-4 border-t border-t-[#E1E6E1]">
      <div className="flex justify-between items-center ">
        <p className="text-[#2E332F] font-semibold text-sm ">
          Order placed by {name}
        </p>
        <p className="text-[#79887B] font-medium text-xs ">{time}</p>
      </div>
      <div className="flex items-center gap-2">
        <p className="text-[#79887B] font-semibold text-xs ">Payment status:</p>
        {paymentStatus ? (
          <div className="bg-primary rounded-[4px] text-white flex justify-center gap-1 items-center px-1 py-[2px]">
            <Check style={{ width: "12px", height: "12px", color: "white" }} />
            <p className="text-white font-semibold text-xs ">Paid</p>
          </div>
        ) : (
          <div className="bg-[#FEF0EC] rounded-[4px] text-[#B92020] flex justify-center gap-1 items-center px-1 py-[2px]">
            <Cancel
              style={{ width: "12px", height: "12px", color: "#B92020" }}
            />
            <p className="text-[#B92020] font-semibold text-xs ">Unpaid</p>
          </div>
        )}
      </div>

      <div className="flex items-center gap-2">
        <p className="text-[#79887B] font-semibold text-xs ">
          Stock confirmation:
        </p>
        <div className="border border-[#D4A407] text-[#D4A407] rounded-[4px] flex justify-center gap-1 items-center px-1 py-[2px]">
          <Schedule
            style={{ width: "12px", height: "12px", color: "#D4A407" }}
          />
          <p className="text-[#D4A407] font-semibold text-xs ">
            Pending Approval
          </p>
        </div>
      </div>
    </div>
  );
};

export const StockConfirmation = ({ name, time, department }) => {
  return (
    <div className="py-3  flex flex-col gap-2 px-4 border-t border-t-[#E1E6E1]">
      <div className="flex justify-between items-center ">
        <div className="flex items-center gap-2">
          <p className="text-[#2E332F] font-semibold text-sm ">{name}</p>

          <div className="bg-[#F6F7F6] rounded-[4px] text-[#5F6D60] border border-[#E1E6E1] flex justify-center gap-1 items-center px-1 py-[2px]">
            <p className="text-[#5F6D60] font-semibold text-xs ">
              {department}
            </p>
          </div>
        </div>
        <p className="text-[#79887B] font-medium text-xs ">{time}</p>
      </div>
      <div className="flex items-center gap-2">
        <p className="text-[#79887B] font-semibold text-xs ">
          Changed stock confirmation status from
        </p>

        <div className="flex items-center gap-2">
          <div className="border border-[#D4A407] text-[#D4A407] rounded-[4px] flex justify-center gap-1 items-center px-1 py-[2px]">
            <Schedule
              style={{ width: "12px", height: "12px", color: "#D4A407" }}
            />
            <p className="text-[#D4A407] font-semibold text-xs ">
              Pending Approval
            </p>
          </div>
          <p className="text-[#79887B] font-semibold text-xs ">to</p>

          <div className="border border-primary rounded-[4px] text-primary flex justify-center gap-1 items-center px-1 py-[2px]">
            <DoneAll
              style={{ width: "12px", height: "12px", color: "#2B8C34" }}
            />
            <p className="text-primary font-semibold text-xs ">Confirmed</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export const NotInStock = ({ name, time, department, note }) => {
  return (
    <div>
      {/* NOT IN STOCK */}
      <div className="py-3  flex flex-col gap-2 px-4 border-t border-t-[#E1E6E1]">
        <div className="flex justify-between items-center ">
          <div className="flex items-center gap-2">
            <p className="text-[#2E332F] font-semibold text-sm ">{name}</p>

            <div className="bg-[#F6F7F6] rounded-[4px] text-[#5F6D60] border border-[#E1E6E1] flex justify-center gap-1 items-center px-1 py-[2px]">
              <p className="text-[#5F6D60] font-semibold text-xs ">
                {department}
              </p>
            </div>
          </div>
          <p className="text-[#79887B] font-medium text-xs ">{time}</p>
        </div>
        <div className="flex items-center gap-2">
          <p className="text-[#79887B] font-semibold text-xs ">
            Changed stock confirmation status from
          </p>

          <div className="flex items-center gap-2">
            <div className="border border-[#D4A407] text-[#D4A407] rounded-[4px] flex justify-center gap-1 items-center px-1 py-[2px]">
              <Schedule
                style={{ width: "12px", height: "12px", color: "#D4A407" }}
              />
              <p className="text-[#D4A407] font-semibold text-xs ">
                Pending Approval
              </p>
            </div>
            <p className="text-[#79887B] font-semibold text-xs ">to</p>

            <div className="border border-[#B92020] bg-white rounded-[4px] text-[#B92020] flex justify-center gap-1 items-center px-1 py-[2px]">
              <Clear
                style={{ width: "12px", height: "12px", color: "#B92020" }}
              />
              <p className="text-[#B92020] font-semibold text-xs ">
                Not in stock
              </p>
            </div>
          </div>
        </div>

         <div className="mt-2 border border-[#EDECE7] overflow-hidden rounded-lg">
          <div className="bg-[#F6F7F6] px-[6px] py-[6px] border-b border-b-[#E1E6E1]">
            <p className="text-[#79887B] font-semibold text-xs ">
              Rejection Note ({note?.title})
            </p>
          </div>
          <div className="py-2 px-[6px] bg-white">
            <p className="text-[#79887B] font-medium text-xs ">
              {note?.text || "No note provided"}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export const Alternative = ({ name, time, department }) => {
  return (
    <div className="py-3  flex flex-col gap-2 px-4 border-t border-t-[#E1E6E1]">
      <div className="flex justify-between items-center ">
        <div className="flex items-center gap-2">
          <p className="text-[#2E332F] font-semibold text-sm ">{name}</p>

          <div className="bg-[#F6F7F6] rounded-[4px] text-[#96A397] flex justify-center gap-1 items-center px-1 py-[2px]">
            <p className="text-[#5F6D60] font-semibold text-xs ">
              {department}
            </p>
          </div>
        </div>
        <p className="text-[#79887B] font-medium text-xs ">{time}</p>
      </div>
      <div className="flex items-center gap-2">
        <p className="text-[#79887B] font-semibold text-xs ">
          Changed stock confirmation status from
        </p>

        <div className="flex items-center gap-2">
          <div className="border border-[#D4A407] text-[#D4A407] rounded-[4px] flex justify-center gap-1 items-center px-1 py-[2px]">
            <Schedule
              style={{ width: "12px", height: "12px", color: "#D4A407" }}
            />
            <p className="text-[#D4A407] font-semibold text-xs ">
              Pending Approval
            </p>
          </div>
          <p className="text-[#79887B] font-semibold text-xs ">to</p>

          <div className="border border-[#0066AF] bg-white rounded-[4px] text-[#0066AF] flex justify-center gap-1 items-center px-1 py-[2px]">
            <Shuffle
              style={{ width: "12px", height: "12px", color: "#0066AF" }}
            />
            <p className="text-[#0066AF] font-semibold text-xs ">Alternative</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export const DeliveryDetails = ({ name, time, department, info }) => {
  return (
    <div className="py-3  flex flex-col gap-2 px-4 border-t border-t-[#E1E6E1]">
      <div className="flex justify-between items-center ">
        <div className="flex items-center gap-2">
          <p className="text-[#2E332F] font-semibold text-sm capitalize ">
            {name}
          </p>

          <div className="bg-[#F6F7F6] rounded-[4px] text-[#96A397] flex justify-center gap-1 items-center px-1 ">
            <p className="text-[#5F6D60] font-semibold text-xs ">
              {department}
            </p>
          </div>
        </div>
        <p className="text-[#79887B] font-medium text-xs ">{time}</p>
      </div>
      <div className="flex items-center gap-2">
        <p className="text-[#79887B] font-semibold text-xs ">Added</p>

        <div className="flex items-center gap-2">
          <div className="border border-[#2E332F] text-[#2E332F] rounded-[4px] flex justify-center gap-1 items-center px-1 py-[2px]">
            <p className="text-[#2E332F] font-semibold text-xs ">
              Delivery Details
            </p>
          </div>
        </div>
      </div>

      <div className="bg-[#F7F7F5] border border-[#EDECE7] py-1 px-2 rounded-lg">
        {/* ADDRESS */}
        <div className="flex gap-2 border-b py-2 border-b-[#E1E6E1] items-center">
          <p className="text-[#79887B] font-semibold text-xs ">Address:</p>
          <div className="bg-white border border-[#E1E6E1] px-1 py-[2px] rounded-[4px] ">
            <p className="text-[#5F6D60] font-semibold text-xs ">
              {info?.address || "No address provided"}
            </p>
          </div>
        </div>

        {/* STATE */}
        <div className="flex gap-2 border-b py-2 border-b-[#E1E6E1] items-center">
          <p className="text-[#79887B] font-semibold text-xs ">State:</p>
          <div className="bg-white border border-[#E1E6E1] px-1 py-[2px] rounded-[4px] ">
            <p className="text-[#5F6D60] font-semibold text-xs ">
              {" "}
              {info?.state || "No address provided"}
            </p>
          </div>
        </div>

        {/* LGA */}
        <div className="flex gap-2 border-b py-2 border-b-[#E1E6E1] items-center">
          <p className="text-[#79887B] font-semibold text-xs ">LGA:</p>
          <div className="bg-white border border-[#E1E6E1] px-1 py-[2px] rounded-[4px] ">
            <p className="text-[#5F6D60] font-semibold text-xs ">
              {info?.lga || "No address provided"}
            </p>
          </div>
        </div>

        {/* ESTIMATED DELIVERY DATE */}
        <div className="flex gap-2 border-b py-2 border-b-[#E1E6E1] items-center">
          <p className="text-[#79887B] font-semibold text-xs ">
            Estimated Delivery Date:
          </p>
          <div className="bg-white border border-[#E1E6E1] px-1 py-[2px] rounded-[4px] ">
            <p className="text-[#5F6D60] font-semibold text-xs ">
              {" "}
              {moment(info?.estimated_date).format("DD/MM/YYYY") ||
                "No address provided"}
            </p>
          </div>
        </div>

        {/* DELIVERY TYPE*/}
        <div className="flex gap-2 py-2  items-center">
          <p className="text-[#79887B] font-semibold text-xs ">
            Delivery Type:
          </p>
          <div className="bg-white border border-[#E1E6E1] px-1 py-[2px] rounded-[4px] flex items-center gap-1">
            <Moped
              style={{ width: "13px", height: "13px", color: "#5F6D60" }}
            />
            <p className="text-[#5F6D60] font-semibold text-xs capitalize ">
              {" "}
              {info?.delivery_type?.replace("_", "") || "N/A"}{" "}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};
